import SelectOption from "@/common/ui/presenters/select-option";
import { client as request } from "../../api/request";
import StaffApi, { ListStaffQuery } from "@/api/staff-api";

/**
 * 工程の施工者のフィルターの候補を得る
 */
export async function getOperatorFilterOptions(
  query: ListStaffQuery = {}
): Promise<SelectOption[]> {
  // TODO: mapの中身だけ切り出して、プレゼンテーション側に置いた方がいいかも
  return (await new StaffApi(request).getAll(query)).map(s => ({
    text: s.name,
    value: String(s.id)
  }));
}

/**
 * セルビスタスクのマスタを取得する
 */
export async function getMasterConstructionTask(serviceTaskTypeId: string) {
  const res = await request.get("get_m_construction_task.php", {
    serviceTaskTypeId
  });
  return res;
}
